// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"shadow-card-component_uk-open__zuqNy","grecaptcha-badge":"shadow-card-component_grecaptcha-badge__cwVii","shadow-card":"shadow-card-component_shadow-card__YbjSX"};
    if(module.hot) {
      // 1756311252863
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  